import React from 'react';

import { OPComponent } from '../components';

import PersonalForm from './personal_form';

import { SUCCESS } from '../../actions/statusTypes';
export default class CaseFieldsConsumer extends OPComponent {
  constructor(props) {
    super(props);

    if (props.editingCase) {
      let { caseId, name, patientName, description, ailment, roleId, timeZone } = props.editingCase;

      let patientObj = props.editingCasePatient;
      this.state = {
        caseId,
        name,
        patientName: patientObj ? patientObj.fullName : patientName,
        patientEmail: patientObj ? patientObj.email : null,
        description,
        ailment,
        roleId,
        timeZone: timeZone || 'America/Los_Angeles',
      };
      this._storeOrigValsFromState();
    } else {
      this.state = {
        caseId: null,
        name: null,
        patientName: null,
        patientEmail: null,
        description: null,
        roleId: 1,
      };
    }

    this._formRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      this._storeOrigValsFromState();
      this.props.onSave();
    }
  }

  _storeOrigValsFromState() {
    this._origVals = {
      ...this.state,
    };
  }

  needsSaving() {
    if (!this.props.editingCase) return true;

    let needsSave = false;
    for (var key in this.state) {
      needsSave = needsSave || this.state[key] !== this._origVals[key];
      if (needsSave) break;
    }

    return needsSave;
  }

  submit = () => {
    console.info('>>> submit');
    if (!this.needsSaving()) {
      this.props.onSave();
      return true;
    }

    const formIsValid = this._formRef.current?.validate();
    if (!formIsValid) {
      return false;
    }

    let caseObj = {
      name: this.state.name,
      patientName: this.state.patientName,
      description: this.state.description,
      roleId: this.state.roleId,
      ailment: this.state.ailment || null,
    };

    if (this.state.caseId != null) {
      caseObj.timeZone = this.state.timeZone;
      this.props.updateCase(this.state.caseId, caseObj);
    } else {
      this.props.addCase(caseObj);
    }

    return true;
  };

  handleChangeValue = (val) => {
    this.setState(val);
  };

  render() {
    const { editingCase, componentId, editingCasePatient } = this.props;
    const { caseId, name, patientName, patientEmail, description, roleId, timeZone, ailment } =
      this.state;

    return (
      <PersonalForm
        ref={this._formRef}
        componentId={componentId}
        caseId={caseId}
        name={name}
        patientName={patientName}
        patientEmail={patientEmail}
        description={description}
        ailment={ailment}
        roleId={roleId}
        timeZone={timeZone}
        handleChangeValue={this.handleChangeValue}
        hasPatientObj={!!editingCasePatient}
      />
    );
  }
}
